import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { getTriggersService, deleteTriggerService, toggleTriggerService } from "../../selectors/triggerService";
import { TriggerForm } from "./TriggerForm";

export const TriggerList = ({ courseId, canvasId }) => {
  const [triggers, setTriggers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingTrigger, setEditingTrigger] = useState(null);

  useEffect(() => {
    loadTriggers();
  }, [courseId]);

  const loadTriggers = () => {
    getTriggersService(courseId)
      .then((resp) => {
        if (resp.data.status || resp.data.success) {
          setTriggers(resp.data.data || []);
        }
      })
      .catch((error) => {
        console.error("Error al cargar triggers:", error);
      });
  };

  const handleDelete = (id) => {
    swal({
      title: "¿Eliminar trigger?",
      text: "Esta acción no se puede deshacer",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteTriggerService(id)
          .then((resp) => {
            if (resp.data.status || resp.data.success) {
              swal("Trigger eliminado", "", "success");
              loadTriggers();
            }
          })
          .catch((error) => {
            swal("Error", "No se pudo eliminar el trigger", "error");
          });
      }
    });
  };

  const handleToggle = (id) => {
    toggleTriggerService(id)
      .then((resp) => {
        if (resp.data.status || resp.data.success) {
          loadTriggers();
        }
      })
      .catch((error) => {
        swal("Error", "No se pudo cambiar el estado", "error");
      });
  };

  const handleEdit = (trigger) => {
    setEditingTrigger(trigger);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setEditingTrigger(null);
    loadTriggers();
  };

  return (
    <div className="mt-5">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl Metropolis-Bold color-titulos">
          Actividades Configuradas
        </h2>
        <button
          onClick={() => setShowForm(true)}
          className="py-2.5 bg-[#93b33a] text-white Metropolis-Bold text-xs leading-tight uppercase rounded-md shadow-md hover:bg-[#93b33a] hover:shadow-lg px-4"
        >
          + Agregar Actividad
        </button>
      </div>

      {triggers.length === 0 ? (
        <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 rounded">
          <p className="Metropolis-Bold">ℹ️ No hay triggers configurados</p>
          <p className="text-sm mt-2">
            Las certificaciones se generarán automáticamente cuando los estudiantes
            alcancen la nota mínima del curso (nota final).
          </p>
          <p className="text-sm mt-1">
            Para generar certificados basados en actividades específicas, agregue una actividad.
          </p>
        </div>
      ) : (
        <div className="bg-[#67b5dd] rounded-[12px] p-5">
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded mb-4">
            <p className="Metropolis-Bold">
              Actividades activas: {triggers.filter((t) => t.active).length}
            </p>
            <p className="text-sm">
              Los certificados se generarán cuando los estudiantes aprueben las actividades configuradas.
            </p>
          </div>

          <table className="min-w-full border border-[#243F59] text-center rounded-[12px] overflow-hidden">
            <thead className="bg-[#243f59]">
              <tr>
                <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                  Actividad Canvas
                </th>
                <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                  ID Canvas
                </th>
                <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                  Nota Mínima
                </th>
                <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left border-r">
                  Estado
                </th>
                <th className="text-sm text-white Metropolis-Bold px-4 py-4 text-left">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {triggers.map((trigger, index) => (
                <tr
                  key={trigger.id}
                  className={index % 2 === 0 ? "bg-[#ececec]" : "bg-white"}
                >
                  <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r text-left">
                    {trigger.assignment_name}
                  </td>
                  <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r text-left">
                    {trigger.canvas_assignment_id}
                  </td>
                  <td className="text-sm text-gray-900 Metropolis-Light px-4 py-4 border-r text-left">
                    {trigger.minimum_score}
                  </td>
                  <td className="text-sm px-4 py-4 border-r text-left">
                    <span
                      className={`px-3 py-1 rounded-full text-xs Metropolis-Bold ${
                        trigger.active
                          ? "bg-green-200 text-green-800"
                          : "bg-gray-200 text-gray-800"
                      }`}
                    >
                      {trigger.active ? "✅ Activo" : "⏸️ Inactivo"}
                    </span>
                  </td>
                  <td className="text-sm px-4 py-4 text-left">
                    <div className="flex gap-2">
                      <button
                        onClick={() => handleToggle(trigger.id)}
                        className="text-blue-600 hover:text-blue-800"
                        title={trigger.active ? "Desactivar" : "Activar"}
                      >
                        <img
                          className="w-6"
                          src={`/assets/icons/${
                            trigger.active ? "validate-ok.png" : "validate-no.png"
                          }`}
                          alt="Toggle"
                        />
                      </button>
                      <button
                        onClick={() => handleEdit(trigger)}
                        className="text-blue-600 hover:text-blue-800"
                        title="Editar"
                      >
                        <img
                          className="w-6"
                          src="/assets/icons/edit.png"
                          alt="Editar"
                        />
                      </button>
                      <button
                        onClick={() => handleDelete(trigger.id)}
                        className="text-red-600 hover:text-red-800"
                        title="Eliminar"
                      >
                        <img
                          className="w-6"
                          src="/assets/icons/delete.png"
                          alt="Eliminar"
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showForm && (
        <TriggerForm
          courseId={courseId}
          canvasId={canvasId}
          trigger={editingTrigger}
          onClose={handleCloseForm}
        />
      )}
    </div>
  );
};
